/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc
 */

export let ComHubspotBuyingModelsRpcProductAbstractPublicProductRpcError;
(function (_ComHubspotBuyingModelsRpcProductAbstractPublicProductRpcError) {})(ComHubspotBuyingModelsRpcProductAbstractPublicProductRpcError || (ComHubspotBuyingModelsRpcProductAbstractPublicProductRpcError = {}));
export let ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError;
(function (_ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError) {})(ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError || (ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError = {}));
export const getProductsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getProducts',
  auth: 'external',
  fingerprint: 'y60Ckx8OiE98ic51ILFzTZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicProductsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductsV2',
  auth: 'external',
  fingerprint: 'y60Ckx8OiE98ic51ILFzTfIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBundleRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getBundle',
  auth: 'external',
  fingerprint: 'XsmoUCK1QFLeGrqy_S_6wJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAddOnsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getAddOns',
  auth: 'external',
  fingerprint: 'W1sIsXps8S0cTK6AliWoS5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicAddOnsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicAddOnsV2',
  auth: 'external',
  fingerprint: 'W1sIsXps8S0cTK6AliWoS_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGrowthPurchaseOptionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getGrowthPurchaseOptions',
  auth: 'external',
  fingerprint: 'pVh7oN-TcNvNcgDdIob235wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicGrowthPurchaseOptionsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicGrowthPurchaseOptionsV2',
  auth: 'external',
  fingerprint: 'pVh7oN-TcNvNcgDdIob23_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGrowthPurchaseOptionsUsingCombinedTermsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getGrowthPurchaseOptionsUsingCombinedTerms',
  auth: 'external',
  fingerprint: 'zzlNdeJljzvOvw0uJxxD4pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicCurrencyResponseRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicCurrencyResponse',
  auth: 'external',
  fingerprint: 'LcY_1HcXExpCxNsiV75fV5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicCurrencyV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicCurrencyV2',
  auth: 'external',
  fingerprint: 'LcY_1HcXExpCxNsiV75fV_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicPhoneNumberRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicPhoneNumber',
  auth: 'external',
  fingerprint: '3XnPSFhmU52JvnxBO5sLIUIvbGFwJ20M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicPhoneNumberV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicPhoneNumberV2',
  auth: 'external',
  fingerprint: '3XnPSFhmU52JvnxBO5sLIfIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicFeatureFlagsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicFeatureFlags',
  auth: 'external',
  fingerprint: 'xqbfhmS3i9U9llyZwSnPm0IvbGFwJ20M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicFeatureFlagsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicFeatureFlagsV2',
  auth: 'external',
  fingerprint: 'xqbfhmS3i9U9llyZwSnPm_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPublicPricingPageDetailsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicPricingPageDetails',
  auth: 'external',
  fingerprint: 'yMREVRptkqIpmSkMPLJIb0IvbGFwJ20M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};